import React from "react";
import { Footer } from "@excalidraw/excalidraw/index";
import { ExcalidrawPlusAppLink } from "./ExcalidrawPlusAppLink";
import { isExcalidrawPlusSignedUser } from "../app_constants";
import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";

/* The encryption-shield icon (with its "end-to-end encrypted" tooltip) is
 * intentionally not rendered — the bottom-right corner stays clear for the
 * lesson UI. */
export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    return (
      <Footer>
        <div
          style={{
            display: "flex",
            gap: ".5rem",
            alignItems: "center",
          }}
        >
          {isVisualDebuggerEnabled() && <DebugFooter onChange={onChange} />}
          {isExcalidrawPlusSignedUser && <ExcalidrawPlusAppLink />}
        </div>
      </Footer>
    );
  },
);
